import { useAccountCrumbs } from '@thd-olt-component-react/customer-account-navigation';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';
import React, { useEffect } from 'react';
import { BusinessToolsHeader } from '../components/business-tools';
import { SpendByDepartment } from '../components/business-tools/SpendByDepartment';
import { SpendMap } from '../components/business-tools/SpendMap';
import { TopItems } from '../components/business-tools/TopItems';
import { TopJobs } from '../components/business-tools/TopJobs';
import PageLayout from '../components/shared/PageLayout';
import BusinessToolsProvider from '../contexts/BusinessToolsContext';
import { setBusinessToolsPageAnalytics } from '../utils/business-tools/analytics';
import '../styles/business-tools.scss';
export var BusinessTools = function (props) {
    var customerType = props.customerType, customerRole = props.customerRole;
    var crumbs = useAccountCrumbs([
        {
            label: 'Track Business Spend',
            path: '/myaccount/business-tools',
        },
    ]);
    useEffect(function () {
        setBusinessToolsPageAnalytics();
    }, []);
    return (React.createElement(PageLayout, { crumbs: crumbs, pageTitle: "Track Business Spend", customerRole: customerRole, customerType: customerType, internalRoutes: ['/myaccount/business-tools'] },
        React.createElement(BusinessToolsProvider, null,
            React.createElement("div", { className: "sui-flex business-tools sui-max-w-[1039px]" },
                React.createElement("div", { className: "business-tools__mobilePadding", style: { width: '100%', paddingBottom: 5 } },
                    React.createElement(ErrorBoundary, { name: "business-tools-header" },
                        React.createElement(BusinessToolsHeader, null)),
                    React.createElement(ErrorBoundary, { name: "top-jobs" },
                        React.createElement(TopJobs, null)),
                    React.createElement(ErrorBoundary, { name: "top-items" },
                        React.createElement(TopItems, null)),
                    React.createElement(ErrorBoundary, { name: "spend-map" },
                        React.createElement(SpendMap, null)),
                    React.createElement(ErrorBoundary, { name: "spend-by-department" },
                        React.createElement(SpendByDepartment, null)))))));
};
BusinessTools.displayName = 'Track Business Spend';
